import Nullstack from 'nullstack';
export default function IconItalic({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-italic",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "5",
    x2: "17",
    y2: "5"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "19",
    x2: "13",
    y2: "19"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "5",
    x2: "10",
    y2: "19"
  }), " ");
}